export default "__VITE_ASSET__CClEdkgU__"